module.exports = __webpack_public_path__ + "img/PPMP32.1a1269f2.png";